import { getUserInfo } from '../services/login.service';
import { LoginFlowState } from '../enums';
import { staticConfig } from '../config/static';

export const noAccess = (logonPath: string): boolean => {
    if (logonPath === 'USE_NONE') {
        return true;
    } else {
        return false;
    }
};

export function getLoginState(params: URLSearchParams, props: any): LoginFlowState {
    if (params.has('Login') && params.get('Login') === 'true') {
        return LoginFlowState.ForceLogin;
    } else if (params.has('logout') && params.get('logout') === 'done') {
        return LoginFlowState.Logout;
    } else if (params.has('logout') && params.get('logout') === 'init') {
        return LoginFlowState.LoggedInCheckIfLoggedOutAction;
    } else if (params.has('askcpr') && params.get('askcpr') === 'true') {
        return LoginFlowState.AskCpr;
    } else if (params.has('token') && staticConfig.temporaryTokenDebug) {
        return LoginFlowState.TokenDebug;
    } else if (props.isAuthorized && localStorage.getItem('loginFlowComplete') === 'true') {
        return LoginFlowState.Login;
    } else if (params.get('code') && params.get('state') && checkState(params.get('state'))) {
        return LoginFlowState.CompleteLoginFlow;
    } else if (window.localStorage.getItem('isAuthenticated')) {
        return LoginFlowState.UpdateAndGetUserToken;
    }
    return LoginFlowState.Default;
}

export function checkState(state: string): boolean {
    const savedState = sessionStorage.getItem('codeState');
    return (savedState === null && state !== null) || savedState === state;
}

export function getUser(props: any) {
    return getUserInfo().then((data) => {
        sessionStorage.setItem('userOrganizationName', data.org_name);
        sessionStorage.setItem('userOrganizationId', '3');
        sessionStorage.setItem('userName', data.name);
        props.loginUser(data.sub);
    });
}
